export const colors = {
  hoverRed: '#F44336',
  white: 'white',
};
